import { bool, func, node, string, shape } from 'prop-types'
import { Component } from 'react'
import Conditional from '../Conditional'
import { kuiperClassNames } from '../utils'
import FormFooter from './FormFooter'
import FormHeader from './FormHeader'
import './styles.scss'

class Form extends Component {
  static propTypes = {
    children: node,
    customClass: string,
    description: string,
    formMeta: shape({
      title: string,
      info: node,
      warn: bool,
      error: bool,
    }),
    onScroll: func,
    onWheel: func,
  }

  static defaultProps = {
    formMeta: {
      title: '',
      info: '',
      warn: false,
      error: false,
    },
  }

  constructor(props) {
    super(props)
    this.state = {
      animateInfo: false,
    }

    this.createFooterInfoRef = this.createFooterInfoRef.bind(this)
    this.toggleFooterInfoAnimation = this.toggleFooterInfoAnimation.bind(this)
  }

  componentDidMount() {
    if (this.footerInfoRef) {
      this.footerInfoRef.addEventListener(
        'animationend',
        this.toggleFooterInfoAnimation
      )
    }
  }

  componentDidUpdate(nextProps) {
    if (
      nextProps.formMeta &&
      nextProps.formMeta.info !== this.props.formMeta.info
    ) {
      this.toggleFooterInfoAnimation()
    }
  }

  get otherProps() {
    // eslint-disable-next-line no-unused-vars
    const { children, description, ...otherProps } = this.props

    return otherProps
  }

  createFooterInfoRef(element) {
    this.footerInfoRef = element
  }

  toggleFooterInfoAnimation() {
    this.setState((lastState) => ({ animateInfo: !lastState.animateInfo }))
  }

  render() {
    return (
      <div className={kuiperClassNames('form-wrapper')}>
        <FormHeader {...this.otherProps} />
        <form
          className={kuiperClassNames(this.props.customClass)}
          onScroll={this.props.onScroll}
          onWheel={this.props.onWheel}
        >
          <Conditional condition={Boolean(this.props.description)}>
            <p className={kuiperClassNames('form-description')}>
              {this.props.description}
            </p>
          </Conditional>
          <div className={kuiperClassNames('form-contents')}>
            {this.props.children}
          </div>
        </form>
        <FormFooter
          animateInfo={this.state.animateInfo}
          infoRef={this.createFooterInfoRef}
          {...this.otherProps}
        />
      </div>
    )
  }
}

export default Form
